import script from "./EffectControlsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./EffectControlsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./EffectControlsPanel.vue?vue&type=style&index=0&id=c8eb20d0&lang=scss"

const __exports__ = script;

export default __exports__